import React from 'react'
import IrregularInteraction from '../IrregularInteraction'
import ItemImage from '../ItemImage'
import image from '../../assets/images/item--entertainment-system@3x.png'

const points =
  '176.26 68.79 176.26 1.63 173.44 0 50.1 71.21 50.1 131.7 0 160.68 0 212.61 1.4 213.41 1.4 215.82 56.69 247.52 220.73 152.62 220.73 150.17 224.17 148.18 224.17 96.25 176.26 68.79'

const tvPath =
  'M176.26,1.63,173.44,0,50.1,71.21v79.46l2.82,1.63s15.8-7.67,34.45-17.5L104,144.39l43-24.84v-1.4l-15-8.68c22.56-13.86,44.27-28.39,44.27-28.39Z'

const boxesPath =
  'M159.8,136.49l-31.57,18.3-3.95,2.29-2.66,1.54-21.76,12.6v15.94l6.14,3.55h0l31.61-18.26v-4.58l4,2.31h0l4.15-2.39a2.57,2.57,0,0,0,.86-.33,4.38,4.38,0,0,0,.86-.66l25.75-14.87v-7.65Z'

const EntertainmentSystem = props => (
  <IrregularInteraction
    points={points}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 224.17 247.52"
    sparksTop={-2}
    sparksLeft={0}
    sparksRotation={163}
    {...props}
    highlight={false}
  >
    <IrregularInteraction
      path={tvPath}
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 224.17 247.52"
      sparksTop={-2}
      sparksLeft={0}
      sparksRotation={163}
      {...props}
    />
    <IrregularInteraction
      path={boxesPath}
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 224.17 247.52"
      sparksTop={-2}
      sparksLeft={0}
      sparksRotation={163}
      {...props}
    />
    <ItemImage src={image} />
  </IrregularInteraction>
)

EntertainmentSystem.propTypes = IrregularInteraction.propTypes

export default EntertainmentSystem



// WEBPACK FOOTER //
// ./src/components/items/EntertainmentSystem.js